"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var metadata_1 = require("./metadata");
//import Monitor from '../monitor';
var Store_1 = __importDefault(require("../Store"));
var usageTracker_1 = require("./usageTracker");
var auth_1 = require("../utils/auth");
var Customer = "brp";
var RenderQuality;
(function (RenderQuality) {
    RenderQuality["Fast"] = "Fast";
    RenderQuality["Good"] = "Good";
    RenderQuality["Better"] = "Better";
    RenderQuality["Best"] = "Best";
})(RenderQuality || (RenderQuality = {}));
var RenderMode;
(function (RenderMode) {
    RenderMode["_3D"] = "3D";
    RenderMode["_2D"] = "2D";
})(RenderMode = exports.RenderMode || (exports.RenderMode = {}));
;
var streamMetricHistory = [];
var latestPrCodes = [];
function evaluateStreamingEnv() {
    var addr = window.location.host.split(".");
    var env = addr.length > 1 ? addr[0].replace("offroad", "") : "live";
    if (env.startsWith("sitebuild-")) {
        env = env.split("-")[1];
    }
    if (window.zlurlparams.env) {
        env = window.zlurlparams.env;
        console.log("StreamingEnvSelect via param", env);
    }
    else {
        var h = window.location.host;
        if (h.indexOf("zlthunder.net") >= 0) {
            if (h.indexOf("-test") >= 0) {
                env = "prelive";
            }
            else if (h.indexOf("-dev") >= 0) {
                env = "stage";
            }
        }
        else if (h.indexOf(":") > 0) {
            env = "stage";
        }
        console.log("StreamingEnvSelect dynamic @", h, "(" + env + ")");
    }
    return env;
}
exports.evaluateStreamingEnv = evaluateStreamingEnv;
exports.getDefaultConnectionParams = function () {
    var localaddr = "";
    if (window.zlurlparams.localstream) {
        localaddr = window.zlurlparams.localstream;
    }
    if (localaddr.length > 0 && localaddr.indexOf("/zlm/sub/") < 0) {
        //Should query ZLManager here to determine an appropriate sub slot rather than just assuming 0
        localaddr = localaddr + "/zlm/sub/0";
    }
    var maxX = 1280;
    var maxY = 720;
    var env = evaluateStreamingEnv();
    var urlCP = {};
    if (window.zlurlparams.region) {
        urlCP["region"] = window.zlurlparams.region;
    }
    // if we're on stage we can safely assume this region and cut out all the enumeration stuff
    if (env === "stage") {
        if (urlCP["region"] === undefined || urlCP["region"] === null) {
            urlCP["region"] = "eu-west-1";
        }
    }
    urlCP["environment"] = env;
    if (window.zlurlparams.sw) {
        maxX = parseInt(window.zlurlparams.sw);
        if (maxX > 1920) {
            maxX = 1920;
        }
        maxY = (maxX / 16) * 9;
    }
    var idleDowngrade = 60000 * (env === "assetpreview" ? 5 : 3); // take longer to time out during approvals
    var doReconnects = window.zlurlparams.doreconnects;
    var modes = window.zlurlparams.force2d ? ["2D"] : ["2D", "3D"];
    var connectionParameters = {
        "connectionParameters": __assign(__assign({ "customer": Customer }, urlCP), { "protocol": "https" }),
        "parent": "streamContainer",
        "resolution": {
            "x": maxX,
            "y": maxY
        },
        "car": {
            "manufacturer": "",
            "model": "",
            "year": ""
        },
        "loadingScreen": false,
        "modes": modes,
        "allow2DFallback": true,
        "allow3DUpgrade": !window.zlurlparams.force2d,
        "force2DCacheMiss": window.zlurlparams.forcecachemiss,
        "setupPrCodes": "",
        "setupEnvironment": "brp_studio",
        "setupCamera": "Free_Orbit_Exterior",
        "mouseClickPassthrough": true,
        "localControl": false,
        "showDownloadButton": false,
        "idleOverlay": false,
        "idleDisconnect": doReconnects ? idleDowngrade : -1,
        "keepLastFrameOnIdleDisconnect": doReconnects,
        "idleDowngrade": doReconnects ? -1 : idleDowngrade,
        "movableCameraBehaviour": "manual",
        "onDemand2DConfig": {
            "showProgressBar": false,
            "onDemand2D360ViewRules": {
                "loadAuto": !window.zlurlparams.lazygenerate2d,
                "loadOnRotation": window.zlurlparams.lazygenerate2d,
                "loadOnMoveCamera": window.zlurlparams.lazygenerate2d
            }
        },
        "idleConfig": {
            "initialWindow": 0,
            "initialTimeout": 10000,
            "extendedTimeout": 10000 // Timeout to use after the initialWindow time period
        },
        "modeSwitchConfig": {
            "transitionType": "crossfade"
        },
        "scalingConfig": {
            "showOverflow": true,
            "autoScale": true,
            "update3DOutputResolution": true,
            "profileSwitchingRules": {
                "default": "default"
            },
            "qualitySettings3D": {},
            "profiles": {
                "default": {
                    "2D": {
                        "bounds": { "min": [0, 0], "max": [9999, 9999] },
                        "permittedSizes": [[1280, 720], [1920, 1080]],
                        "scaleMode": "fill"
                    },
                    "3D": {
                        "bounds": { "min": [0, 0], "max": [9999, 9999] },
                        "streamResolutionBounds": { "min": [maxX / 5, maxY / 5], "max": [maxX, maxY] },
                        "aspectRatio": maxX / maxY,
                        "scaleMode": "fill"
                    }
                }
            }
        }
    };
    if (parseInt(window.zlurlparams.modelyear) >= 2022 || window.zlurlparams.platform.toLowerCase().startsWith("ssv_storm")) {
        var _2dconfig = connectionParameters.onDemand2DConfig;
        _2dconfig.interiorMSAA = 2;
        _2dconfig.interiorSSAA = 4;
        _2dconfig.defaultMSAA = 2;
        _2dconfig.defaultSSAA = 4;
    }
    if (window.zlurlparams.cas) {
        connectionParameters["casURL"] = window.zlurlparams.cas;
        connectionParameters.connectionParameters["customer"] = "proto";
        connectionParameters.connectionParameters["mainDomain"] = window.zlurlparams.mainDomain;
        connectionParameters.connectionParameters["region"] = undefined;
        connectionParameters["force2DCacheMiss"] = true;
    }
    else if (localaddr.length > 0) {
        connectionParameters["directConnect"] = localaddr + "/ve";
    }
    return connectionParameters;
};
function zlQueryMetadata(metadataprocessor, onError) {
    var _this = this;
    var _a;
    if (!((_a = window.zlbolt) === null || _a === void 0 ? void 0 : _a.getCurrentMode())) {
        getAPI().then(function (libZL) { return __awaiter(_this, void 0, void 0, function () {
            var metadataOverride, response, json, e_1, options, service, metadata, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!((libZL === null || libZL === void 0 ? void 0 : libZL.discoverService) !== undefined)) return [3 /*break*/, 13];
                        metadataOverride = getMetaDataEndpointOverride();
                        if (!metadataOverride) return [3 /*break*/, 6];
                        console.log("Getting metadata from override endpoint: " + metadataOverride);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(metadataOverride)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        metadataprocessor(json.metadata);
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        console.error("Failed to get metadata", e_1);
                        onError();
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 12];
                    case 6:
                        console.log("Getting metadata from LibZL");
                        options = { connectionParameters: { environment: evaluateStreamingEnv(), customer: Customer }, token: auth_1.getToken() };
                        _a.label = 7;
                    case 7:
                        _a.trys.push([7, 10, , 12]);
                        return [4 /*yield*/, window.libZL.discoverService(options)];
                    case 8:
                        service = _a.sent();
                        return [4 /*yield*/, service.getAssetMetadata(metadataOverride ? { api3D: { metadata: metadataOverride } } : undefined)];
                    case 9:
                        metadata = _a.sent();
                        try {
                            metadataprocessor(metadata.extendedMetadata);
                        }
                        catch (e) {
                            console.error("Failed to process metadata", e);
                        }
                        return [3 /*break*/, 12];
                    case 10:
                        e_2 = _a.sent();
                        console.error("Failed to discover any services", e_2);
                        return [4 /*yield*/, auth_1.forceReauth()];
                    case 11:
                        _a.sent();
                        zlQueryMetadata(metadataprocessor, onError);
                        return [3 /*break*/, 12];
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        console.log("LibZL version doesn't support discoverService");
                        onError();
                        _a.label = 14;
                    case 14: return [2 /*return*/];
                }
            });
        }); });
    }
    else {
        window.zlbolt.getAssetMetadata(function (error, metadata, extendedMetadata) {
            metadataprocessor(extendedMetadata);
        });
    }
}
exports.zlQueryMetadata = zlQueryMetadata;
function zlConnect(params, onSuccess, onFail) {
    if (window.zlbolt) {
        utils_1.timeoutPromise(30000, new Promise(function (resolve, reject) {
            window.zlbolt.connect(__assign(__assign({}, params), { token: auth_1.getToken() }), function (err, response) {
                if (err) {
                    reject(err.message || (response || {}).reason || 'unexpected error');
                    return;
                }
                if (onSuccess) {
                    onSuccess();
                }
                resolve();
            }).catch(function (err) {
                reject("Unexpected error during connect");
            });
        }), "zlBoltConnect").catch(function (error) {
            if (onFail) {
                onFail("Failed connection caught by global timeout");
                try {
                    window.zlbolt.disconnect();
                }
                catch (err) {
                    console.log("error during zlbolt disconnect call", err);
                }
            }
        }).then(function () {
            //console.log("Connection phase complete");
        });
    }
}
exports.zlConnect = zlConnect;
function zlValidate(params, cb) {
    if (window.zlbolt) {
        if (!params.car.manufacturer || !params.car.model || !params.car.year) {
            if (cb) {
                cb(undefined, { "status": "failed", "reason": "Attempting to connect without car info, missing master model?" });
                return;
            }
            throw new Error("Attempting to connect without car info");
        }
        window.zlbolt.validate(__assign(__assign({}, params), { token: auth_1.getToken() }), cb);
    }
}
exports.zlValidate = zlValidate;
function getAPI() {
    return new Promise(function (resolve, reject) {
        if (typeof window !== 'undefined') {
            var interval_1;
            interval_1 = setInterval(function () {
                if (window.libZL !== undefined && window.libZL !== null) {
                    clearInterval(interval_1);
                    resolve(window.libZL);
                }
            }, 50);
        }
        else {
            reject();
        }
    });
}
function getMetaDataEndpointOverride() {
    var metadataOverride = window.zlurlparams.metadataOverrideLocation;
    if (window.zlurlparams.localstream) {
        metadataOverride = metadataOverride || window.zlurlparams.localstream + "/zlm/localmetadataservice/";
    }
    if (metadataOverride) {
        if (!metadataOverride.startsWith("http")) {
            metadataOverride = window.location.protocol + "//" + metadataOverride;
        }
    }
    else {
        metadataOverride = null;
    }
    return metadataOverride;
}
function createZLAPI(comp, onDone, onStreamReady, onStreamReconnected, onStreamDisconnected, onError, onModeChange, highlightColor) {
    getAPI().then(function (lib) {
        comp.setState(__assign(__assign({}, comp.state), { libZL: lib }));
        lib.zlbolt(Customer).then(function (zlbolt) {
            if (typeof window !== 'undefined') {
                //Adding event listeners to what we're interested in
                window.zlbolt = zlbolt;
            }
            try {
                zlbolt.overrideMetadataEndpoint(getMetaDataEndpointOverride());
            }
            catch (_a) {
                //Not incognito safe...
            }
            zlbolt.movableExteriorCamera = 'Free_Orbit_Exterior';
            zlbolt.movableInteriorCamera = 'InteriorStatic'; //This is intentionally not SteeringWheel_L0L to avoid our settings getting stomped.
            if (highlightColor) {
                zlbolt.highlightColor = highlightColor;
            }
            var events = ['mousedown', 'mousemove', 'keypress', 'touchstart'];
            events.forEach(function (name) {
                document.addEventListener(name, function (ev) {
                    if (ev.isTrusted && (ev.type !== 'mousemove' || ev.buttons !== 0)) {
                        if (zlbolt.streamIsActive) {
                            //Monitor.registerInteraction(ev);
                            zlbolt.clearStreamIdleTimeout();
                        }
                        else {
                            if (window.zlurlparams.doreconnects) {
                                if (zlbolt.reconnect !== undefined) {
                                    zlbolt.reconnect({ setupPrCodes: _injectOrientation(latestPrCodes) }, function (error) {
                                        if (!error) {
                                            if (onStreamReconnected) {
                                                onStreamReconnected();
                                            }
                                        }
                                    });
                                }
                                else {
                                    console.log("Re-connect was expected but not not currently supported.");
                                }
                            }
                        }
                    }
                }, { capture: true, passive: true });
            });
            zlbolt.addEventListener('error', function (error) {
                try {
                    if (error.errorCode === "TOKEN_INVALID") {
                        auth_1.forceReauth();
                    }
                    console.log('Zlbolt had an error: ', error);
                    if (onError) {
                        onError();
                    }
                }
                catch (e) {
                    console.error("Exception thrown during error CB", e);
                }
            });
            zlbolt.addEventListener('streamReady', function () {
                try {
                    console.log('The stream is ready!');
                    usageTracker_1.recordModeChange(zlbolt.getCurrentMode());
                    onStreamReady();
                }
                catch (e) {
                    console.error("Exception thrown during streamReady CB", e);
                }
            });
            zlbolt.addEventListener('onStreamDisconnect', function (_, reason) {
                console.log('Stream disconnected');
                try {
                    onStreamDisconnected(reason);
                }
                catch (e) {
                    console.error("Exception thrown during onStreamDisconnect CB", e);
                }
            });
            zlbolt.addEventListener('streamMetricsUpdated', function (data) {
                try {
                    if (streamMetricHistory.push(__assign({ timestamp: Date.now() }, data)) > 60) {
                        streamMetricHistory.shift();
                    }
                }
                catch (e) {
                    console.error("Exception thrown during streamMetricsUpdated CB");
                }
            });
            zlbolt.addEventListener('streamDidDowngrade', function () {
                var _a;
                (_a = window.zltagger) === null || _a === void 0 ? void 0 : _a.UCXX_streamdowngraded(true);
            });
            zlbolt.addEventListener('cameraMoved', function (args, args2) {
                var _a;
                console.log("Camera Moved", args, args2);
                (_a = window.zltagger) === null || _a === void 0 ? void 0 : _a.UCXX_cameramoved();
            });
            zlbolt.addEventListener('modeChange', function (mode, status) {
                var _a;
                try {
                    if (onModeChange) {
                        onModeChange(mode, status === "pending");
                    }
                }
                catch (e) {
                    console.error("Exception thrown during modeChange CB", e);
                }
                try {
                    if (mode === "2D") {
                        // if for whatever reason we're swapping to 2D and the camera is currently flycam,
                        // change to a different camera or we'll get a bad result on screen.
                        if (status === "pending") {
                            if (zlbolt.getCamera() === "CloudFlyCam") {
                                zlbolt.switchCamera(zlbolt.movableExteriorCamera);
                            }
                        }
                        if (status === "success") {
                            (_a = window.zltagger) === null || _a === void 0 ? void 0 : _a.UCXX_streamdowngraded(false);
                        }
                        usageTracker_1.recordModeChange(mode);
                    }
                }
                catch (e) {
                    console.error("Exception thrown during modeChange CB", e);
                }
            });
            /*
            zlbolt.addEventListener('adoptionInformation', (details: any) => {
                console.log("adoptionInformation", details);
            });*/
            comp.setState({
                zlbolt: zlbolt
            }, function () {
                onDone();
            });
        });
    }).catch(function (error) {
        console.error("didn't get lib: " + error);
        if (onError) {
            onError();
        }
    });
}
exports.createZLAPI = createZLAPI;
function changeEnvironment(target) {
    if (typeof window !== 'undefined' && window.zlbolt !== undefined) {
        if (target) {
            // select a specific env
            window.zlbolt.switchEnvironment(target); //.toLowerCase());
            utils_1.taggingUpdateEnvironment(target);
        }
        else {
            // cycles through available envs
            window.zlbolt.enumerateEnvironments(function (a, e) {
                var nextEnv = e.environments.indexOf(e.current.toLowerCase()) + 1;
                var newEnv = e.environments[(nextEnv + 1) % e.environments.length];
                window.zlbolt.switchEnvironment(newEnv);
            });
        }
    }
}
exports.changeEnvironment = changeEnvironment;
function checkCurrentEnv(cb) {
    if (typeof window !== 'undefined' && window.zlbolt !== undefined) {
        cb(window.zlbolt.getEnvironment());
    }
}
exports.checkCurrentEnv = checkCurrentEnv;
function getStreamingEnv() {
    if (window.zlbolt !== undefined) {
        return window.zlbolt.options.connectionParameters.environment;
    }
    return "";
}
exports.getStreamingEnv = getStreamingEnv;
function screenshotDownload(width, height) {
    if (typeof window !== 'undefined' && window.zlbolt !== undefined) {
        window.zlbolt.screenshotCapture(width, height);
    }
}
exports.screenshotDownload = screenshotDownload;
function getScreenshotURL(width, height, format) {
    return utils_1.timeoutPromise(10000, new Promise(function (resolve, reject) {
        if (typeof window !== 'undefined' && window.zlbolt !== undefined) {
            var url = window.zlbolt.getScreenshotURL({ width: width, height: height, format: format }, function (err, res) {
                resolve(res.url);
            });
            if (url !== null) {
                resolve(url);
            }
            else {
                if (window.zlbolt.getCurrentMode() === "3D") {
                    reject("bad url returned from zlbolt");
                }
            }
        }
        else {
            reject("zlbolt undefined");
        }
    }), "screenshot").catch(function (reason) {
        console.log("Was unable to get URL for screenshot");
    });
}
function screenshotCapture(width, height, format) {
    return new Promise(function (resolve, reject) {
        if (typeof window !== 'undefined' && window.zlbolt !== undefined) {
            var details_1 = undefined;
            var assets_1 = undefined;
            getScreenshotURL(width, height, format).then(function (url) {
                fetch(url)
                    .then(function (data) {
                    details_1 = data.headers.get("X-ZL-Screenshot-Details");
                    assets_1 = data.headers.get("X-ZL-Asset-Versions");
                    console.log(details_1);
                    console.log(assets_1);
                    return data.blob();
                })
                    .then(function (blob) {
                    resolve({ blob: blob, details: details_1, assets: assets_1 });
                })
                    .catch(function (error) {
                    console.log("screenshot error", error);
                    reject(error);
                });
            });
        }
        else {
            reject("zlbolt undefined");
        }
    });
}
exports.screenshotCapture = screenshotCapture;
function changeCamera(id, done) {
    if (window.zlbolt) {
        window.zlbolt.switchCamera(id, function () {
            if (done) {
                done(window.zlbolt.getCamera());
            }
        });
    }
}
exports.changeCamera = changeCamera;
function getCamera() {
    if (window.zlbolt) {
        return window.zlbolt.getCamera();
    }
    return "";
}
exports.getCamera = getCamera;
function initDirect2D(options) {
    window.libZL.direct2D('zlthunder.net').then(function (api) {
        return api.connect(options, function () {
            console.log("2d connection done!");
        }).catch(function (error) {
            console.log("error during init2d", error);
        });
    }).then(function (direct2D) {
        window.direct2D = direct2D;
    }).catch(function (error) {
        console.log("error during init2d --", error);
    });
}
exports.initDirect2D = initDirect2D;
function _injectRemovals(codes) {
    var _a;
    var finalcodes = [];
    var state = Store_1.default.getState();
    var cardata = state.EnvironmentInfo.vehicle;
    var car = state.EnvironmentInfo.mastermodel;
    if (cardata !== undefined && Object.keys(cardata).length > 0) {
        var id = [car.manufacturer, car.model, car.year].join(" ");
        var carmeta = cardata[id];
        if ((_a = carmeta === null || carmeta === void 0 ? void 0 : carmeta.metadata) === null || _a === void 0 ? void 0 : _a.codeTranslation) {
            // values for this currently stored in metadata.userdata items
            var removals = carmeta.metadata.codeTranslation.removals || {};
            var _loop_1 = function (code) {
                for (var _i = 0, _a = Object.keys(removals); _i < _a.length; _i++) {
                    var removalType = _a[_i];
                    if (finalcodes.includes(removalType)) {
                        continue;
                    }
                    var removers = removals[removalType];
                    if (removers.some(function (l) { return l === code || (l.code === code && metadata_1.processLogic(codes, l)); })) {
                        finalcodes.push(removalType);
                    }
                }
                finalcodes.push(code);
            };
            for (var _i = 0, codes_1 = codes; _i < codes_1.length; _i++) {
                var code = codes_1[_i];
                _loop_1(code);
            }
        }
        else {
            finalcodes = codes;
        }
        return finalcodes;
    }
    return codes;
}
exports._injectRemovals = _injectRemovals;
function _injectOrientation(prcodes) {
    if (process.env.REACT_APP_DEDICATED_MOBILE_PORTRAIT_CAMERAS && window.matchMedia) {
        if (window.matchMedia("(max-width: 1023px) and (orientation: portrait) and (pointer:coarse)").matches) {
            return __spreadArrays(prcodes, ["zl_view_mobile_portrait"]);
        }
    }
    return prcodes;
}
exports._injectOrientation = _injectOrientation;
function _setPrCodes(prstring) {
    latestPrCodes = _injectRemovals(prstring);
    if (window.zlbolt && window.zlbolt.streamIsActive) {
        return window.zlbolt.setPrCodes(_injectOrientation(latestPrCodes));
    }
}
function _highlightCodes(effectName, currentcodes, newcodes) {
    var z = window.zlbolt;
    if (!window.zlurlparams.nofx && z && newcodes.length > 0) {
        if (z.applyPartSwitchEffect !== undefined && z.getCurrentMode("3D")) {
            var partColour = window.zlbolt.highlightColor;
            var carColor = "#ffffff";
            z.applyPartSwitchEffect(_injectRemovals(newcodes).join(","), { prcodes: _injectOrientation(_injectRemovals(currentcodes)), effectName: effectName, partColour: partColour, carColor: carColor });
            return;
        }
    }
    _setPrCodes(currentcodes);
}
function setNewPrCodes(newCodes, showChangeEffect) {
    if (showChangeEffect === void 0) { showChangeEffect = true; }
    var bs = Store_1.default.getState().BuildSession.current;
    if (bs) {
        newCodes = metadata_1.filterNonVisualCodes(bs.getModelRangeName(false), bs.getModelYear(false), newCodes);
        if (showChangeEffect) {
            var oldprcodes = Store_1.default.getState().BuildSession.activecodes;
            if (oldprcodes) {
                oldprcodes = metadata_1.filterNonVisualCodes(bs.getModelRangeName(false), bs.getModelYear(false), oldprcodes);
            }
            var newBits = [];
            for (var _i = 0, newCodes_1 = newCodes; _i < newCodes_1.length; _i++) {
                var newCode = newCodes_1[_i];
                if (!oldprcodes.includes(newCode)) {
                    newBits.push(newCode);
                    var typeForItem = bs.getCategoryForItemId(newCode); // this won't find features (which is as desired)
                    if (typeForItem === undefined) {
                        showChangeEffect = false;
                    }
                }
            }
            if (newBits.length > 0 && showChangeEffect) {
                var effect = window.zlurlparams.doPreview ? "CAR_PAINT_PART_FIT" : "CAR_PAINT_PART_PREVIEW";
                _highlightCodes(effect, newCodes, newBits);
                return;
            }
        }
    }
    _setPrCodes(newCodes);
}
exports.setNewPrCodes = setNewPrCodes;
function previewPrCodes(bs, previewcodes, showPreviewEffect, isFeature) {
    // "previews" in 3D only until someone suggests otherwise?
    if (window.zlbolt && window.zlbolt.getCurrentMode("3D")) {
        var buildcodes = bs.getPRCodes();
        var prcodes = metadata_1.filterNonVisualCodes(bs.getModelRangeName(false), bs.getModelYear(false), buildcodes);
        if (isFeature.length > 0) {
            var currentFeatureCode = bs.getFeatureCode(isFeature);
            var fi = prcodes.indexOf(currentFeatureCode);
            if (fi >= 0) {
                prcodes[fi] = previewcodes[0];
                previewcodes = [];
            }
        }
        else {
            var used_1 = [];
            for (var pc = 0; pc < previewcodes.length; pc++) {
                var pcType = bs.getCategoryForItemId(previewcodes[pc]);
                if (pcType) {
                    for (var f = 0; f < prcodes.length; f++) {
                        if (bs.getCategoryForItemId(prcodes[f]) === pcType) {
                            console.log("Swapping " + prcodes[f] + " for " + previewcodes[pc]);
                            prcodes[f] = previewcodes[pc];
                            used_1.push(previewcodes[pc]);
                            break;
                        }
                    }
                }
            }
            prcodes = prcodes.concat(previewcodes.filter(function (code) { return used_1.indexOf(code) < 0; }));
        }
        //CAR_PAINT_PART_RICHDATA_HIDE
        //CAR_PAINT_PART_PREVIEW
        if (showPreviewEffect) {
            var fx = window.zlurlparams.capturediv ? "CAR_PAINT_PART_TEST" : "CAR_PAINT_PART_PREVIEW";
            _highlightCodes(fx, prcodes, previewcodes);
        }
        else {
            _setPrCodes(prcodes);
        }
    }
}
exports.previewPrCodes = previewPrCodes;
function requestImage(params) {
    return new Promise(function (resolve, reject) {
        if (window.direct2D) {
            var d2d = window.direct2D;
            var u = d2d.options.car;
            var fc = {
                camera: {
                    specification: 'named',
                    name: params.camera ? params.camera : 'Hero'
                },
                prcodes: params.prcodes ? params.prcodes : Store_1.default.getState().BuildSession.activecodes,
                environment: params.env ? params.env : window.zlbolt.getEnvironment(),
                size: params.size ? params.size : [512, 512],
                car: params.unit ? params.unit : [u.manufacturer, u.model, u.year].join(" "),
                render_quality: params.render_quality ? params.render_quality : "Good",
                token: auth_1.getToken()
            };
            if (params.background_colour !== undefined) {
                fc["background_colour"] = params.background_colour;
                fc["format"] = "png";
            }
            var frameconfig = d2d.makeFrameConfig(fc);
            console.log(fc);
            var frameRequest_1 = d2d.fetchFrames([frameconfig], { loadImages: true });
            Object.keys(frameRequest_1.frames).forEach(function (filename, i) {
                var frame = frameRequest_1.frames[filename];
                frame.readyPromise.then(function () {
                    resolve(frame.url);
                });
            });
        }
        else {
            reject("direct 2D not initialised?");
        }
    });
}
exports.requestImage = requestImage;
function currently3D() {
    if (window.zlbolt) {
        if (window.zlbolt.getCurrentMode() === RenderMode._3D) {
            return true;
        }
    }
    return false;
}
exports.currently3D = currently3D;
function setCurrentMode(mode) {
    if (window.zlbolt) {
        return window.zlbolt.setCurrentMode(mode);
    }
}
exports.setCurrentMode = setCurrentMode;
function toggleRenderMode() {
    setCurrentMode(currently3D() ? RenderMode._2D : RenderMode._3D);
}
exports.toggleRenderMode = toggleRenderMode;
function captureConfig() {
    if (window.zlbolt) {
        var t = new Date();
        var state = Store_1.default.getState();
        var envInfo = state.EnvironmentInfo;
        var bs = state.BuildSession.current;
        var config = {
            connectionparams: window.zlbolt.options.connectionParameters,
            unit: __assign(__assign({}, window.zlbolt.options.car), { sku: bs ? bs.getModelSku() : "unknown" }),
            builduuid: bs.state.uuid,
            prcodes: window.zlbolt.getPrCodes(),
            camera: window.zlbolt.getCamera(),
            environment: window.zlbolt.getEnvironment(),
            time: t.toLocaleString("en-GB"),
            timestamp: t.getTime(),
            streamingenv: {
                assets: envInfo.assets || {},
                viewer: envInfo.viewer || {}
            },
            webpage: envInfo.webpage || {},
            href: envInfo.href,
            useragent: window.navigator.userAgent,
            streammetrics: streamMetricHistory,
            instanceIP: (window.zlbolt.getStreamController() || {}).cloudIp || null,
            mode: window.zlbolt.getCurrentMode() || null,
            shortcode: state.BuildSession.shortcode
            // etc. etc. etc.
        };
        return config;
    }
    return {};
}
exports.captureConfig = captureConfig;
//# sourceMappingURL=libzl.js.map